export const BASE_URL = 'https://test.guvrix.com';
//export const BASE_URL = 'https://member.guvrix.com';
// export const BASE_URL = 'https://cuzdrivenew.reviewmydata.com';
//export const BASE_URL = 'https://demo.guvrix.com';